import { loginClearError, storeUserMetadata } from '../store/login/login.actions';
import { loginComplete } from '../store/login/login.actions';
import { Login } from '../components/login';
import { retailerApi } from '@common/retailer-api';
import { getPortalBaseUrlForCurrentHost } from '../utils/iam-login-url';
const {
  useEffect
} = React;
const {
  useDispatch,
  useSelector
} = ReactRedux;
const logger = svs.core.log.getLogger('welcome:LoginContainer');
export const LoginContainer = () => {
  const dispatch = useDispatch();
  const [getRetailerInfo, {
    data: retailerInfo,
    error: retailerInfoError
  }] = retailerApi.useLazyGetUserProfileQuery();
  const {
    hasStoredUserMetadata,
    isAuthenticated,
    isComplete,
    isMissingUserMetadata,
    error
  } = useSelector(({
    login
  }) => login);
  const hasToChangePassword = useSelector(({
    login
  }) => login.isComplete && login.mustChangePassword);
  const isIamFlow = new URLSearchParams(window.location.search).get('iam') === '1';
  useEffect(() => {
    if (isAuthenticated && !isComplete) {
      logger.info('Username: Fetching retailer info after authentication', {
        isAuthenticated,
        isComplete
      });
      getRetailerInfo();
    }
  }, [isAuthenticated, isComplete, getRetailerInfo]);
  useEffect(() => {
    if (retailerInfo) {
      logger.info('Username: Retailer metadata received', {
        retailerId: retailerInfo?.retailer?.id,
        hasRetailerInfo: Boolean(retailerInfo)
      });
      dispatch(storeUserMetadata(retailerInfo));
    }
    if (retailerInfoError) {
      logger.info('Username: Error fetching retailer info', {
        error: retailerInfoError?.message || retailerInfoError?.error?.message
      });
    }
  }, [dispatch, retailerInfo, retailerInfoError]);
  useEffect(() => {
    if (hasStoredUserMetadata) {
      logger.info('Username: Metadata stored successfully, completing login');
      dispatch(loginComplete());
    }
  }, [dispatch, hasStoredUserMetadata, isIamFlow]);
  const handleCloseMetadataErrorDialog = () => dispatch(loginComplete());
  const handleCloseErrorDialog = () => {
    dispatch(loginClearError());
    window.location.assign(getPortalBaseUrlForCurrentHost());
  };
  useEffect(() => {
    if (!error) {
      return;
    }
    if (isIamFlow) {
      const code = error.code || 665;
      logger.info(`category="IAM Users" action="IAM Login Failure" label="username" code="${code}"`);
    }
  }, [error, isIamFlow]);
  return <Login error={error} hasMissingUserMetadata={Boolean(retailerInfoError) || isMissingUserMetadata} hasToChangePassword={hasToChangePassword} isAuthenticated={isAuthenticated} isComplete={isComplete} onCloseErrorDialog={handleCloseErrorDialog} onCloseMetadataErrorDialog={handleCloseMetadataErrorDialog} />;
};